<template>
    <section class="publication">
        <div class="container">

            <div class="row">
                <div class="col-md-12">

                    <div class="publication__heading d-flex">
                        <publication-progress :step-info="{ info: currentStepComponent.progress, count: initial.length }" />
                        <h2 v-if="currentStepComponent">{{ currentStepComponent.title }}</h2>
                        <span v-if="currentStepComponent.subtitle" class="publication__subtitle">{{ currentStepComponent.subtitle }}</span>
                        <button v-if="!currentStepComponent.required" type="button" class="btn publication__btn"
                                @click.prevent="handleTransform('increment')"
                        >Пропустить</button>
                    </div>

                </div>
            </div>

            <div class="publication__content">
                <div class="row">
                    <div class="col-md-12">
                        <div class="publication__slider" ref="slider" :style="{maxHeight: `${sliderHeight}px`}" >

                            <div class="publication__slider-track clearfix"
                                 :style="{width: `${trackWidth}px`, transform: `translateX(${trackTransform}px)`}">

                                <template v-if="initial.length">

                                    <template v-for="(s, idx) in initial">

                                        <div class="publication__slider-slide" ref="slides" :style="{width: `${slideWidth}px`}" :key="idx">
                                            <component :server="server" @parent-update="stepUpdate" ref="stepRefs" :is="s.component.name"></component>
                                        </div>

                                    </template>

                                </template>

                            </div>

                        </div>

                    </div>
                </div>
            </div>

            <div class="row" v-if="step < initial.length - 1">
                <div class="col-md-12">
                    <div class="publication__nav d-flex">
                        <button type="button" class="btn publication__btn publication__btn--primary"
                                @click.prevent="submitForm" :disabled="disableActionButton"
                        >
                            {{
                                (currentStepComponent.valid && !disableActionButton  && $store.getters.t('publication_submit_save_and_moderate')) ||
                                (disableActionButton && 'Please wait while we verify your data') ||
                                'Correct the errors and try again'
                            }}
                        </button>
                    </div>
                </div>
            </div>

        </div>
    </section>
</template>

<script>

import {paginationScrollTo} from '../../helpers/helpers';

import createAutoHelp from "./createAutoHelp";
import createGiveAway from "./createGiveAway";
import createPhotoHelp from "./createPhotoHelp";

import SliderMixin from "../mixins/SliderMixin";
import StateMixin from "../mixins/StateMixin";

import PublicationProgress from '../PublicationProgress';
import PublicationSuccess from './PublicationSuccess';
import AutoHelp from './AutoHelp';
import PhotoHelp from './PhotoHelp';
import GiveAwayHelp from './GiveAwayHelp';

export default {
    name: "index.vue",
    props: ['server'],
    mixins: [SliderMixin, StateMixin],
    components: {
        PublicationProgress, AutoHelp, PhotoHelp, GiveAwayHelp, PublicationSuccess
    },
    data(){

        return{

            slides: [],
            merge_model: false,

        }

    },

    created() {

        const edit = this.server.model && Object.keys(this.server.model).length
                    && window.location.pathname.search(/\/facility\/\d+$/g);

        if( edit && this.server.model.type ) this.SET_PUBLICATION_TYPE(this.server.model.type);

        const type = this.GET_PUBLICATION_TYPE;

        if( ! type ) return window.location.href = `${window.location.origin}/publication`

        this.slides = {
            'auto_help' : createAutoHelp,
            'giveaway'  : createGiveAway,
            'photo_help': createPhotoHelp,
            'pr_help'   : createPhotoHelp,
        }[ type ]

        this.CREATE_STATE_BY_KEY('facility');
        this.SET_BY_KEY({key: 'type', data: type});

        if ( edit ) {

            this.merge_model = true;

            const prepareState = {

                selectedCities: this.server.model.cities,
                selectedRegions: this.server.model.regions,

                cities: this.server.model.cities.map( e => e.id ),
                regions: this.server.model.regions.map( e => e.id ),

                images: [],

                previewImages: this.server.model['images'].map( photo => {
                    return {
                        id: photo.id,
                        base64: '/storage' + photo.path,
                        name: (
                            (arr) => { return arr[ arr.length - 1 ] }
                        )(photo.path.split('/')),
                    }
                } ),

            };


            Object.keys(this.GET_STATE).forEach( _k => {

                if ( ! this.server.model.hasOwnProperty( _k ) || prepareState.hasOwnProperty( _k ) ) return;

                prepareState[ _k ] = this.server.model[ _k ];

            });

            this.SET_STATE_BY_MODEL( prepareState )

        }

    },

    computed: {
        STORE_ENDPOINT(){

            const u = this.server.model ?
                `/api/facilities/${this.GET_BY_KEY('type').replace('_', '-')}/${this.server.model.id}?_method=PUT` :
                `/api/facilities/${this.GET_BY_KEY('type').replace('_', '-')}`;

            return u;
        },

        cities: {
            get(){ return this.GET_BY_KEY('cities') },
            set( val ) {
                this.SET_BY_KEY({ key: 'cities', data: val })
            }
        },

        regions: {
            get(){ return this.GET_BY_KEY('regions') },
            set( val ) {
                this.SET_BY_KEY({ key: 'regions', data: val })
            }
        },

        range: {
            get() { return this.GET_BY_KEY('range') },
            set( val ) {
                this.SET_BY_KEY({ key: 'range', data: val })
            }
        },

    },

    methods: {
        async submitForm(){

            this.disableActionButton = true;

            const valid = this.$refs.stepRefs[ this.step ].isValid()

            if ( ! valid ) {
                this.handleSliderHeight();
                this.disableActionButton = false;
            }

            if ( valid ){

                if( this.range !== 'city' && this.cities.length ) this.cities = [];

                if( this.range !== 'region' && this.regions.length ) this.regions = [];

                const success = await this.ACTION_STORE( this.STORE_ENDPOINT )

                if( success.success ) {

                    new Promise(res => {

                        paginationScrollTo('.publication__heading');
                        setTimeout(() => {
                            res();
                        }, 700)

                    }).then( () => {
                        this.handleTransform( 'increment' )
                        this.SET_PUBLICATION_TYPE( null )
                        return this.slides[ this.step ].valid = success
                    } )

                } else {
                    this.disableActionButton = false;

                    if (result && result.errors) {
                        for (let key in result.errors) {
                            var message = result.errors[key];
                            if (key.startsWith('images.') && message == 'The ' + key + ' failed to upload.') {
                                alert('Как минимум, одна из фотографий превышает максимально допустимый размер файла (5М)');
                            }
                            if(key == 'avatar' && message == ('The ' + key + ' failed to upload.')) {
                                alert('Размер файла аватара превышает максимально допустимый размер файла (5М)');
                            }
                        }
                    }
                }

            }

        }
    }


}
</script>

<style scoped>

</style>
